import { IOdataField } from './IOdataField';

export class OdataFieldBoolean implements IOdataField {
  private value: boolean;

  constructor(value: boolean) {
    this.value = value;
  }

  toFieldString() {
    return this.value ? `true` : `false`;
  };
}
